import {
  Avatar,
  Box,
  CardContent,
  CardMedia,
  Grid,
  Stack,
  Tooltip,
} from '@mui/material';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { getCategoryColor, normalizeCategoryName } from '../../BlogPage.utils';
import {
  StyledAuthorGrid,
  StyledAuthorName,
  StyledCard,
  StyledCardActions,
  StyledChip,
  StyledDivDescription,
  StyledGridContainer,
  StyledTypographyTitle,
} from './ArticleItem.styles';
import type { ArticleItemProps } from './ArticleItem.types';

export const ArticleItem = ({ article }: ArticleItemProps) => {
  const router = useRouter();

  return (
    <Grid
      size={{
        xs: 12,
        sm: 12,
        md: 6,
        lg: 4,
      }}>
      <Link
        href={`/blog/post/${article?.slug}`}
        style={{ textDecoration: 'none' }}>
        <StyledCard elevation={6}>
          <CardMedia
            component="img"
            alt={`${article.title} image`}
            height="140"
            src={article?.image?.url}
          />
          <CardContent>
            <Box sx={{ display: 'flex', gap: '0.1rem' }}>
              {article.category.map((cat) => (
                <Tooltip
                  title={`Read more blog posts in ${cat?.name}`}
                  key={cat?.name}>
                  <Box
                    onClick={(e) => {
                      e.preventDefault();

                      router.push(
                        `/blog/category/${normalizeCategoryName(cat?.name)}`
                      );
                    }}
                    sx={{ display: 'inline-block' }}>
                    <StyledChip
                      label={cat?.name}
                      size="small"
                      customColor={getCategoryColor(cat?.name)}
                    />
                  </Box>
                </Tooltip>
              ))}
            </Box>
            <StyledTypographyTitle
              gutterBottom
              variant="h4"
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}>
              {article?.title}
            </StyledTypographyTitle>
            <StyledDivDescription
              sx={{
                display: '-webkit-box',
                WebkitLineClamp: 3,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
              dangerouslySetInnerHTML={{
                __html: article?.shortContent,
              }}></StyledDivDescription>
          </CardContent>
          <StyledCardActions>
            <StyledGridContainer container>
              {article.authors.map((author) => (
                <StyledAuthorGrid key={author.Name} xs={12} md={5}>
                  <Avatar
                    alt={author?.Name}
                    src={author?.Avatar?.url}
                    sx={{ width: 32, height: 32 }}
                  />
                  <Stack>
                    <StyledAuthorName variant="body1">
                      {author?.Name}
                    </StyledAuthorName>
                  </Stack>
                </StyledAuthorGrid>
              ))}
            </StyledGridContainer>
          </StyledCardActions>
        </StyledCard>
      </Link>
    </Grid>
  );
};
